<div
	class="absolute -translate-x-1/2 top-1/2 -translate-y-1/2 flex flex-col justify-center items-center text-4xl duration-1000"
	[class]="{
		'transition-all': currentSlideIndex() === startSlideIndex() + 1,
		'transition-none': currentSlideIndex() !== startSlideIndex() + 1,
		'left-1/2': currentSlideIndex() < startSlideIndex() + 1,
		'left-1/4': currentSlideIndex() >= startSlideIndex() + 1,
	}"
>
	<ui-icon [icon]="icon()" class="mb-5" styleClasses="size-32!"></ui-icon>
	<div>{{ 'summary.top_3' | translate }}</div>
	<div class="font-bold">
		{{ slideTitle() | translate | uppercase }}
	</div>
</div>
@if (values()?.length > 0) {
	<div class="absolute left-1/2 top-1/2 -translate-y-1/2">
		<ol class="list-decimal text-7xl font-bold list-inside">
			@for (item of values(); track item.serial; let i = $index) {
				<li [class]="currentSlideIndex() | rankingStyleClasses: startSlideIndex() : i">
					{{ item.name }}
					<span class="text-4xl font-normal">({{ item.value }})</span>
				</li>
			}
		</ol>
	</div>
}
